import React from 'react';
import { cn, toTitleCase } from '../../../lib/utils';
import { VerificationStatus } from '../../../api/AnalysisStep';


export interface VerificationPillProps {
  verfStatus?: VerificationStatus | null;
  className?: string;
}


const getVerificationStyles = (verfStatus?: VerificationStatus | null): { pill: string; dot: string; } => {

  if (verfStatus === null) {
    return {
      pill: 'bg-slate-50 border border-dashed border-slate-300',
      dot: 'bg-slate-300',
    };
  }

  switch (verfStatus) {
    case VerificationStatus.POSITIVE:
      return {
        pill: 'bg-green-50',
        dot: 'bg-green-500',
      };
    case VerificationStatus.NEGATIVE:
      return {
        pill: 'bg-red-50',
        dot: 'bg-red-500',
      };
    case VerificationStatus.WAIVED:
      return {
        pill: 'bg-[#FFF7D6]',
        dot: 'bg-yellow-500',
      };
    case VerificationStatus.NOT_AVAILABLE:
      return {
        pill: 'bg-gray-50',
        dot: 'bg-gray-400',
      };
    default:
      return {
        pill: 'bg-gray-50',
        dot: 'bg-gray-500',
      };
  }
};

/**
 * VerificationPill Component
 * Displays a verification status with a color-coded pill background and a leading colored dot.
 */
export const VerificationPill: React.FC<VerificationPillProps> = ({
  verfStatus,
  className,
}) => {
  const styles = getVerificationStyles(verfStatus);

  // Base classes for the pill itself
  const basePillClasses = "inline-flex items-center px-3.5 py-1 rounded-full text-xs font-medium";
  // Base classes for the dot
  const baseDotClasses = "h-2 w-2 rounded-full mr-1.5";

  const displayText = verfStatus === null
  ? 'Select'
  : verfStatus
  ? toTitleCase(verfStatus)
  : '';

  return (
    <span
      className={cn(
        basePillClasses,
        styles.pill, // Background color for the pill
        "text-xs font-semibold text-gray-600",  // Text color for the status
        className
      )}
    >
      <span
        className={cn(
          baseDotClasses,
          styles.dot // Background color for the dot, matching the text/theme
        )}
      />
      {displayText}
    </span>
  );
};

export const AddStatusPill = (
  <div
    className="
      inline-flex items-center justify-center
      px-2 py-[2px]
      gap-1
      rounded-[8px]
      border border-transparent
      bg-slate-100
      text-xs font-normal leading-4
      text-[#0A0A0A]
      font-sans
    "
  >
    +Add
  </div>
);